
export const downloadableGuides = [
  {
    id: '1',
    title: 'Complete Invoicing Handbook for Tradies',
    description: 'Master professional invoicing with templates, pricing strategies, and payment collection tips.',
    category: 'Business',
    icon: 'ri-file-text-line',
    pages: 32,
    fileSize: '2.4 MB',
    downloadCount: 1250,
    image: 'https://public.readdy.ai/ai/img_res/3fc1f6258e0384aad29f9054bd23ba19.jpg'
  },
  {
    id: '2',
    title: 'HVAC Installation Best Practices',
    description: 'Step-by-step installation guides for residential and commercial HVAC systems.',
    category: 'HVAC',
    icon: 'ri-temp-cold-line',
    pages: 48,
    fileSize: '5.1 MB',
    downloadCount: 890,
    image: 'https://readdy.ai/api/search-image?query=hvac%20air%20conditioning%20installation%20technical%20diagram%20blueprint%20style%20clean%20professional%20document%20layout%20warm%20neutral%20background&width=400&height=300&seq=guide-hvac-1&orientation=landscape'
  },
  {
    id: '3',
    title: 'Plumbing Code Compliance Guide',
    description: 'Navigate Australian plumbing regulations with confidence. Updated for 2024 standards.',
    category: 'Plumbing',
    icon: 'ri-drop-line',
    pages: 56,
    fileSize: '4.8 MB',
    downloadCount: 1100,
    image: 'https://readdy.ai/api/search-image?query=plumbing%20technical%20manual%20document%20with%20pipe%20diagrams%20and%20specifications%20clean%20professional%20layout%20warm%20lighting%20on%20desk&width=400&height=300&seq=guide-plumbing-1&orientation=landscape'
  },
  {
    id: '4',
    title: 'Electrical Safety Checklist Bundle',
    description: 'Comprehensive safety checklists for residential, commercial, and industrial electrical work.',
    category: 'Electrical',
    icon: 'ri-flashlight-line',
    pages: 24,
    fileSize: '1.8 MB',
    downloadCount: 2300,
    image: 'https://readdy.ai/api/search-image?query=electrical%20safety%20checklist%20document%20professional%20format%20with%20icons%20and%20checkboxes%20clean%20modern%20design%20warm%20neutral%20tones&width=400&height=300&seq=guide-electrical-1&orientation=landscape'
  },
  {
    id: '5',
    title: 'Client Communication Templates',
    description: 'Ready-to-use email templates, quote formats, and follow-up scripts for tradies.',
    category: 'Business',
    icon: 'ri-mail-send-line',
    pages: 18,
    fileSize: '1.2 MB',
    downloadCount: 1800,
    image: 'https://readdy.ai/api/search-image?query=professional%20email%20template%20document%20business%20communication%20layout%20clean%20modern%20design%20warm%20office%20setting&width=400&height=300&seq=guide-communication-1&orientation=landscape'
  },
  {
    id: '6',
    title: 'Carpentry Measurement Guide',
    description: 'Precision measurement techniques, conversion charts, and cutting calculations.',
    category: 'Carpentry',
    icon: 'ri-ruler-line',
    pages: 28,
    fileSize: '3.2 MB',
    downloadCount: 750,
    image: 'https://readdy.ai/api/search-image?query=carpentry%20measurement%20guide%20document%20with%20ruler%20diagrams%20and%20wood%20cutting%20specifications%20professional%20layout%20warm%20tones&width=400&height=300&seq=guide-carpentry-1&orientation=landscape'
  },
  {
    id: '7',
    title: 'Job Costing Spreadsheet Templates',
    description: 'Excel and Google Sheets templates for accurate job costing and profit tracking.',
    category: 'Business',
    icon: 'ri-calculator-line',
    pages: 12,
    fileSize: '0.8 MB',
    downloadCount: 3200,
    image: 'https://readdy.ai/api/search-image?query=spreadsheet%20template%20document%20with%20financial%20calculations%20and%20charts%20professional%20business%20format%20clean%20modern%20design&width=400&height=300&seq=guide-costing-1&orientation=landscape'
  },
  {
    id: '8',
    title: 'Workplace Safety Manual',
    description: 'Complete WHS compliance guide with risk assessments and safety procedures.',
    category: 'Safety',
    icon: 'ri-shield-check-line',
    pages: 64,
    fileSize: '6.5 MB',
    downloadCount: 1450,
    image: 'https://readdy.ai/api/search-image?query=workplace%20safety%20manual%20document%20with%20warning%20signs%20and%20safety%20procedures%20professional%20format%20clean%20layout%20warm%20neutral%20background&width=400&height=300&seq=guide-safety-1&orientation=landscape'
  }
];

export const videoTutorials = [
  {
    id: '1',
    title: 'Getting Started with MtaPlannerPro',
    description: 'Complete walkthrough of setting up your account and creating your first invoice.',
    duration: '8:45',
    category: 'Getting Started',
    thumbnail: 'https://readdy.ai/api/search-image?query=software%20tutorial%20video%20thumbnail%20showing%20dashboard%20interface%20clean%20modern%20design%20with%20play%20button%20overlay%20warm%20professional%20lighting&width=600&height=340&seq=video-start-1&orientation=landscape',
    views: 12500
  },
  {
    id: '2',
    title: 'Photo-to-Quote: AI Invoice Generation',
    description: 'Learn how to upload job site photos and generate accurate quotes instantly.',
    duration: '12:30',
    category: 'Features',
    thumbnail: 'https://readdy.ai/api/search-image?query=ai%20technology%20tutorial%20video%20thumbnail%20showing%20photo%20upload%20interface%20modern%20software%20design%20play%20button%20overlay%20warm%20lighting&width=600&height=340&seq=video-ai-1&orientation=landscape',
    views: 8900
  },
  {
    id: '3',
    title: 'Customizing Invoice Templates',
    description: 'Personalize your invoices with your logo, colors, and payment terms.',
    duration: '6:20',
    category: 'Features',
    thumbnail: 'https://readdy.ai/api/search-image?query=invoice%20template%20customization%20tutorial%20video%20thumbnail%20showing%20design%20interface%20clean%20modern%20layout%20play%20button%20warm%20tones&width=600&height=340&seq=video-template-1&orientation=landscape',
    views: 6700
  },
  {
    id: '4',
    title: 'Managing Client Database',
    description: 'Organize your clients, track job history, and automate follow-ups.',
    duration: '10:15',
    category: 'Features',
    thumbnail: 'https://readdy.ai/api/search-image?query=client%20management%20software%20tutorial%20video%20thumbnail%20showing%20contact%20database%20interface%20modern%20design%20play%20button%20overlay&width=600&height=340&seq=video-clients-1&orientation=landscape',
    views: 5400
  },
  {
    id: '5',
    title: 'HVAC Job Quoting Masterclass',
    description: 'Industry-specific tips for accurate HVAC installation and repair quotes.',
    duration: '18:45',
    category: 'Trade Specific',
    thumbnail: 'https://readdy.ai/api/search-image?query=hvac%20technician%20training%20video%20thumbnail%20showing%20air%20conditioning%20system%20professional%20setting%20play%20button%20overlay%20warm%20lighting&width=600&height=340&seq=video-hvac-1&orientation=landscape',
    views: 4200
  },
  {
    id: '6',
    title: 'Plumbing Emergency Quotes',
    description: 'How to quickly generate accurate quotes for emergency plumbing jobs.',
    duration: '14:20',
    category: 'Trade Specific',
    thumbnail: 'https://readdy.ai/api/search-image?query=plumber%20working%20tutorial%20video%20thumbnail%20showing%20pipe%20repair%20professional%20tools%20play%20button%20overlay%20clean%20modern%20style&width=600&height=340&seq=video-plumbing-1&orientation=landscape',
    views: 3800
  }
];

export const resourceFAQs = [
  {
    id: '1',
    question: 'How do I create my first invoice with MtaPlannerPro?',
    answer: 'Simply upload a photo of your job site or manually enter the job details. Our AI will analyze the work required and generate an itemized quote with real supplier prices. You can then customize the invoice and send it directly to your client.'
  },
  {
    id: '2',
    question: 'Are the material prices in quotes accurate and up-to-date?',
    answer: 'Yes! We integrate directly with major Australian suppliers including Bunnings Warehouse. Prices are updated regularly to ensure your quotes reflect current market rates, helping you maintain healthy profit margins.'
  },
  {
    id: '3',
    question: 'Can I customize invoice templates with my business branding?',
    answer: 'Absolutely. You can add your company logo, choose brand colors, customize payment terms, and include your ABN and contact details. Professional templates help you stand out and build client trust.'
  },
  {
    id: '4',
    question: 'What trades does MtaPlannerPro support?',
    answer: 'We support all major trades including HVAC, plumbing, electrical, carpentry, painting, roofing, landscaping, tiling, concreting, and general renovation work. Our AI is trained on thousands of trade-specific jobs.'
  },
  {
    id: '5',
    question: 'How does the photo-to-quote feature work?',
    answer: 'Take a photo of the job site or existing work. Our AI analyzes the image to identify materials, estimate quantities, and calculate labor requirements. It then generates a detailed quote with itemized costs in seconds.'
  },
  {
    id: '6',
    question: 'Can I track which clients have viewed or paid invoices?',
    answer: 'Yes, our Pro plan includes invoice tracking. You will receive notifications when clients open your invoice, and the dashboard shows payment status for all outstanding invoices, helping you manage cash flow effectively.'
  },
  {
    id: '7',
    question: 'Is there a mobile app for creating invoices on-site?',
    answer: 'MtaPlannerPro is fully responsive and works perfectly on mobile browsers. You can create, edit, and send invoices directly from your phone or tablet while on the job site. No app download required.'
  },
  {
    id: '8',
    question: 'How do I download the free guides and templates?',
    answer: 'Simply click the download button on any guide. Free resources are available instantly. Some premium guides require a Pro subscription, which gives you unlimited access to our entire resource library.'
  }
];

export const resourceCategories = [
  { id: 'all', name: 'All Resources', icon: 'ri-apps-line', count: 45 },
  { id: 'guides', name: 'Downloadable Guides', icon: 'ri-file-download-line', count: 12 },
  { id: 'videos', name: 'Video Tutorials', icon: 'ri-video-line', count: 18 },
  { id: 'templates', name: 'Templates', icon: 'ri-file-copy-line', count: 8 },
  { id: 'faq', name: 'FAQ', icon: 'ri-question-line', count: 7 }
];
